import { Header } from '@components/Header';
import React from 'react';

export const CreateMerchantHeader = () => <Header title="Create merchant" />;
